import { defineStore } from 'pinia';
import { ref } from 'vue';
import {useModal} from "~/stores/ModalStore";
const PromoModal = defineAsyncComponent(() => import('~/components/Modals/FirstOrderPromo/PromoModal.vue'));

import {useSettingsStore} from "~/stores/SettingsStore";

export const useNavigationStore = defineStore('navigation_store', () => {
    const errors = ref({});
    const pageCount = ref(0);
    const hasScrolledHalf = ref(false);
    const loading = ref(false);
    const pricesLoading = ref(false);
    const outdated = ref(false);

    const getPageCount = () => pageCount.value;
    const incrementPageCount = () => {
        pageCount.value++;
        if (pageCount.value > 1 && shouldShowPromoModal()) {
            setTimeout(() => useModal().openModal('PromoModal', PromoModal), 1000);
        }
    };

    const setScrolledHalf = () => hasScrolledHalf.value = true;

    const shouldShowPromoModal = () => !useUserStore().isLoggedIn() && pageCount.value > 1 && hasScrolledHalf.value && useSettingsStore().hasAccessToComponent('promo');

    function handleFormErrors(newErrors) {
        if (newErrors && Object.keys(newErrors).length > 0) {
            for (const [key, value] of Object.entries(newErrors)) {
                errors.value[key] = value.join('<br>');
            }
        }
    }

    function has(id) {
        const errorKey = id?.replace(/\[([^\]]+)\]/g, '.$1');
        return errors.value[errorKey]?.length > 0;
    }

    function get(id) {
        const errorKey = id?.replace(/\[([^\]]+)\]/g, '.$1');
        return errors.value[errorKey];
    }

    function remove(id) {
        if (!has(id)) {
            return;
        }
        const errorKey = id?.replace(/\[([^\]]+)\]/g, '.$1');

        delete errors.value[errorKey];
    }

    function cleanErrors() {
        errors.value = {};
    }

    function setLoading(isLoading, prices = false) {
        loading.value = isLoading;
        pricesLoading.value = prices;
    }


    return {
        errors,
        handleFormErrors,
        cleanErrors,
        has,
        get,
        remove,
        getPageCount,
        incrementPageCount,
        setScrolledHalf,
        hasScrolledHalf,
        shouldShowPromoModal,
        loading,
        pricesLoading,
        setLoading,
        outdated
    };
});
